<script setup>
import { PhxIcon } from '@phx-styleguides/jlc';
import { useWatchComparator } from '@maison/composables/watchComparator';

const { count } = useWatchComparator();
</script>

<template>
  <button type="button" class="w-full flex items-center gap-2xs" data-panel-open="watch-comparator-panel">
    <phx-icon icon="compare-16" size="16" class="me-sm" />
    {{ $t('WatchComparator.menu.label') }}
    <span v-if="count" class="tag tag--secondary ms-auto" data-cy="watch-comparator-menu-count">
      {{ $t('WatchComparator.menu.count', { count }) }}
    </span>
  </button>
</template>
